import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({ name: "relative" })
export class RelativePipe implements PipeTransform {

    transform(value: unknown, ...args: unknown[]): any {
        return moment(value).fromNow();
    }

}
